export default {
    "facet": {
        "showFacetTextView": "Show text",
        "showFacetChartView": "Show chart",
        "itemExclude": "Exclude",
        "applyFilters": "{selections, plural, one {Apply filter} other {Apply filters}}",
        "clearFilters": "{selected, plural, one {Clear filter} other {Clear filters}}",
        "loadMore": "Load more",
        "showMore": "Show more",
        "showLess": "Show less",
        "displayed": "Displayed",
        "removeAll": "Remove all",
        "searchPlaceholder": "Search...",
        "itemSelect": "Select this value",
        "itemUnselect": "Unselect this value",
        "filterItem": "Keep documents with {terme}",
        "filterItems" : "Keep documents with ANY of the selected items",
        "filterItemsAnd": "Keep documents with ALL the selected items",
        "excludeItems" : "Exclude document with selected items",
        "clearSelects" : "Clear the current filters",
        "searchItems" : "Search for a value in this list",
        "searchNoResult": "No results",
        "openItem": "Open",
        "closeItem": "Close",
        "authors": {
            "title": "Authors"
        },
        "concepts": {
            "title": "Concepts"
        },
        "company": {
            "title": "Companies"
        },
        "docformat": {
            "title": "Formats"
        },
        "doctype": {
            "title": "Document Types"
        },
        "documentlanguages": {
            "title": "Languages"
        },
        "fileext": {
            "title": "File Extensions"
        },
        "filename": {
            "title": "Filenames"
        },
        "geo": {
            "title": "Places"
        },
        "matchingpartnames": {
            "title": "Matching Partnames"
        },
        "modified": {
            "title": "Dates"
        },
        "person": {
            "title": "People"
        },
        "refine": {
            "title": "Refine Search",
            "input": {
                "label": "Refine",
                "buttonTitle": "Refine",
                "placeholder": "Refine by..."
            }
        },
        "size": {
            "title": "Sizes"
        },
        "tagcloud": {
            "title": "Tag Cloud"
        },
        "title": {
            "title": "Titles"
        },
        "treepath": {
            "title": "Sources"
        },
        "recentQueries": {
            "title": "Recent queries"
        },
        "recentQueriesPublic": {
            "title": "Public recent queries"
        },
        "mySearch": {
            "title": "My Search",
            "itemRemove": "Remove"
        },
        "search": {
            "label": "Search",
            "buttonTitle": "Search",
            "placeholder": "Search...",
            "showSearchForm": "Show search form",
            "hideSearchForm": "Hide search form"
        },
        "range": {
            "year": "{date, date, sqYear}",
            "monthYear": "{date, date, sqMonthYear}",
            "weekYear": "W{week, number, sqWeek} {weekYear, number, sqYear}",
            "apply": "Apply",
            "clear": "Clear",
            "unavailable": "No available range"
        },

        "filters":{
            "add":"Add facet",
            "addAll": "Add all facets",
            "remove":"Remove facet",
            "removeAll": "Remove all facets",
            "setDefaults": "Set Default facets",
            "clear":"Clear filter",
            "moreFilters":"",
            "showFilters":"Show filters",
            "hideFilters":"Hide filters",

            "back": "Back to filters",
            "selectedFilters": "This filter is active in the current query",

            "customizeFacets": "Select facets to display or hide"
        },

        "selectedValue": "This value is selected in the current query",
        "previous": "Previous",
        "next": "Next",
        "filterItemCountTooltip": "{count} possible values for this filter",
    },

    "facetCard": {
        "expand": "Expand",
        "collapse": "Collapse",
        "enlarge": "Enlarge",
        "reduce": "Reduce",
        "openSettings": "Open settings",
        "saveSettings": "Save settings"
    }
};
